export default {"src":"/_next/static/media/Inbox_Rejected.b2476005.svg","height":28,"width":37,"blurWidth":0,"blurHeight":0};